<div class="header">
  <div class="title">アカウント削除</div>
</div>
<mat-dialog-content>
  <div class="content">
    @if (showSpinner) {
      <div class="spinner center">
        <mat-spinner></mat-spinner>
      </div>
    } @else {
    <div class="form-area">
      <form [formGroup]="form">
        <div class="flex">
          <div class="label">ID</div>
          <mat-form-field class="input-area no-line">
            <input matInput
              formControlName="mailaddress"
              (input)="onInput()"
              readonly
              type="text"
              />
          </mat-form-field>
        </div>
        <div class="flex">
          <div class="label">権限</div>
          <mat-form-field floatLabel="never" class="field-auth no-line">
            <mat-select
              formControlName="accountAuth"
              panelWidth=""
              panelClass="tagcategory-select"
              >
              <mat-option *ngFor="let auth of auths" [value]="auth.value">
                {{ auth.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>

        </div>
    </form>
  </div>
}
</div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  @if (isSaving) {
    <mat-spinner diameter="28" class="spinner"></mat-spinner>
  }
  <button mat-raised-button mat-dialog-close>キャンセル</button>
  <button mat-raised-button (click)="onSave()" [disabled]="isSaving" class="yes-btn">削除</button>
</mat-dialog-actions>
